import { render } from "./ATable.vue?vue&type=template&id=036709c0&ts=true"
import script from "./ATable.vue?vue&type=script&lang=ts"
export * from "./ATable.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__